/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outline/16/calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="none" _stroke="#272c33" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path pid="0" d="M14.5 2.5h-13a1 1 0 00-1 1v11a1 1 0 001 1h13a1 1 0 001-1v-11a1 1 0 00-1-1zM.5 5.5h15M4.5.5v2M11.5.5v2"/><path pid="1" data-color="color-2" d="M5.5 7.5v6M10.5 7.5v6M2.5 10.5h11"/></g>'
  }
})
